<template>
  <div class="mall-quantity-stepper" :class="{ 'mall-quantity-stepper--disabled': disabled }">
    <div class="mall-quantity-stepper__button" @click="change(value - 1)">
      <img :src="disabled ? minusDisabledIcon : minusIcon" alt="수량 빼기" />
    </div>
    <span class="mall-quantity-stepper__value">{{ value }}</span>
    <div class="mall-quantity-stepper__button" @click="change(value + 1)">
      <img :src="disabled ? plusDisabledIcon : plusIcon" alt="수량 더하기" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallQuantityStepper',
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 999,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 화면마다 디자인된 아이콘 색이 달라 아이콘을 받을 수 있게 함
    minusIcon: {
      type: String,
      default: () => require('@/assets/mall/icn_minus_line_active.svg'),
    },
    plusIcon: {
      type: String,
      default: () => require('@/assets/mall/icn_plus_line_active.svg'),
    },
  },
  data() {
    return {
      minusDisabledIcon: require('@/assets/mall/icn_minus_line.svg'),
      plusDisabledIcon: require('@/assets/mall/icn_plus_line_disabled.svg'),
    }
  },
  methods: {
    change(next) {
      if (this.disabled || next < this.min) return
      // 최대 수량에서 더하면 안내할 수 있도록 알림
      if (next > this.max) {
        this.$emit('max-reached', this.max)
        return
      }
      this.$emit('change', next)
    },
  },
}
</script>

<style scoped>
.mall-quantity-stepper {
  display: flex;
  flex-shrink: 0;
  height: 48px;
  padding: 0 16px;
  align-items: center;
  border-radius: 12px;
  background: #F9FAFB;
  box-sizing: border-box;
}

.mall-quantity-stepper--disabled {
  background: #F2F4F6;
}

.mall-quantity-stepper__button {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  cursor: pointer;
}

.mall-quantity-stepper--disabled .mall-quantity-stepper__button {
  cursor: default;
}

.mall-quantity-stepper__button img {
  display: block;
}

.mall-quantity-stepper__value {
  width: 42px;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  text-align: center;
}

.mall-quantity-stepper--disabled .mall-quantity-stepper__value {
  color: #B0B8C1;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallQuantityStepper.vue